import { forwardRef } from 'react';
const Tag = forwardRef(function Tag({ title, meta }, ref) {
	const { color } = meta;
	return ( 
		<div
			ref={ref}
			title={title}
			className={`bg-${color} text-${color} border-${color} px-2 py-0.5 rounded-primary w-[100px] bg-opacity-5 text-center font-medium border-thin truncate select-none`}
		>
			{title}
		</div>
	);
});

export default Tag;